import { authReq } from '@/utils/http'

const getAppInfos = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/app/app_info', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const addAppInfo = (appName, remarks, type) => {
  return authReq.post('/api/v1/app/app_info', {
    'app_name': appName,
    remarks,
    type
  })
}

const getBinInfos = (page = 1, pageSize = 10, sort = '', filters = {}) => {
  return authReq.get('/api/v1/app/bin_info', {
    'page_size': pageSize,
    page,
    sort,
    ...filters
  })
}

const addBinInfo = (formData) => {
  return authReq.uploadPost('/api/v1/app/bin_info', formData)
}

export default {
  getAppInfos,
  addAppInfo,
  getBinInfos,
  addBinInfo
}



// WEBPACK FOOTER //
// ./src/api/appApi.js